module.exports = __webpack_public_path__ + "img/maicapital.dc629eaa.png";